export const setOnlineAppointment = (data: any) => ({
  type: "GET_ONLINE_APPOINTMENT",
  payload: data,
});
